// src/onboarding/activation/kit/scenes.js
// Curated candlestick “scenes” you can pass into lessons.

/** Generic demo scene */
export const demo = [
  { time: "2024-06-01", open: 66000, high: 66750, low: 65500, close: 66500 },
  { time: "2024-06-02", open: 66500, high: 67100, low: 66200, close: 66850 },
  { time: "2024-06-03", open: 66850, high: 67200, low: 66400, close: 66500 },
  { time: "2024-06-04", open: 66500, high: 66800, low: 65800, close: 66100 },
  { time: "2024-06-05", open: 66100, high: 66500, low: 65700, close: 66350 },
  { time: "2024-06-06", open: 66350, high: 67000, low: 66200, close: 66900 },
  { time: "2024-06-07", open: 66900, high: 67500, low: 66650, close: 67300 },
  { time: "2024-06-08", open: 67300, high: 67950, low: 67200, close: 67800 },
  { time: "2024-06-09", open: 67800, high: 69000, low: 67600, close: 68950 },
];

/**
 * Resistance training scene: multiple taps of ~67,000 then a breakout to ~68,950.
 * Range: 2024-06-01 → 2024-06-15
 */
export const resistanceJun1to15 = [
  { time: "2024-06-01", open: 65550, high: 66550, low: 65200, close: 66250 },
  { time: "2024-06-02", open: 66250, high: 66880, low: 66000, close: 66620 },
  { time: "2024-06-03", open: 66620, high: 67020, low: 66380, close: 66690 },
  { time: "2024-06-04", open: 66690, high: 66980, low: 66220, close: 66540 },
  { time: "2024-06-05", open: 66540, high: 67010, low: 66300, close: 66610 },
  { time: "2024-06-06", open: 66610, high: 66990, low: 66280, close: 66650 },
  { time: "2024-06-07", open: 66650, high: 66970, low: 66410, close: 66680 },
  { time: "2024-06-08", open: 66680, high: 67050, low: 66500, close: 66710 },
  { time: "2024-06-09", open: 66710, high: 67120, low: 66520, close: 66990 },
  { time: "2024-06-10", open: 66990, high: 67380, low: 66750, close: 67180 },
  { time: "2024-06-11", open: 67180, high: 67550, low: 67010, close: 67380 },
  { time: "2024-06-12", open: 67380, high: 67920, low: 67250, close: 67750 },
  { time: "2024-06-13", open: 67750, high: 68220, low: 67580, close: 68040 },
  { time: "2024-06-14", open: 68040, high: 68680, low: 67950, close: 68490 },
  { time: "2024-06-15", open: 68490, high: 68950, low: 68320, close: 68780 },
];

/** Optional generator for future lessons */
export function makePullbackScene({ start = 67000, days = 24 } = {}) {
  const out = [];
  let p = start;
  for (let i = 0; i < days; i++) {
    const drift = (i < days * 0.6 ? 120 : 260);
    const noise = (Math.random() - 0.5) * 180;
    const open = p;
    const close = p = Math.max(40000, p + drift + noise);
    const high = Math.max(open, close) + 180 + Math.random() * 120;
    const low  = Math.min(open, close) - 180 - Math.random() * 120;
    out.push({
      time: `2024-07-${String(i + 1).padStart(2, "0")}`,
      open, high, low, close,
    });
  }
  return out;
}

// Nice convenience export (named + default) — either style works.
export const scenes = { demo, resistanceJun1to15, makePullbackScene };
export default scenes;
